// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1y6mE","header":"ReportDetails_header__v3SwC","title":"ReportDetails_title__2nRxk","left":"ReportDetails_left__t8sOp"};